module.exports = __webpack_public_path__ + "img/design@2x.5526855.jpg";